import { Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { isAuthenticated, getCurrentUser } from './utils/api';

// Pages
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import Dashboard from './pages/Dashboard';
import BoardsPage from './pages/BoardsPage';
import BoardDetailPage from './pages/BoardDetailPage';
import WhiteboardPage from './pages/WhiteboardPage';
import MiroWhiteboardPage from './pages/MiroWhiteboardPage';
import ContentPage from './pages/ContentPage';
import AIGeneratorPage from './pages/AIGeneratorPage';
import AnalyticsPage from './pages/AnalyticsPage';

// Components
import Layout from './components/Layout';
import LoadingSpinner from './components/LoadingSpinner';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check authentication status on app load
    const checkAuth = () => {
      if (isAuthenticated()) {
        const currentUser = getCurrentUser();
        setUser(currentUser);
      }
      setLoading(false);
    };

    checkAuth();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="large" />
      </div>
    );
  }

  return (
    <Routes>
      {/* Public routes */}
      <Route 
        path="/login" 
        element={
          !user ? <LoginPage setUser={setUser} /> : <Navigate to="/dashboard" replace />
        } 
      />
      <Route 
        path="/signup" 
        element={
          !user ? <SignupPage setUser={setUser} /> : <Navigate to="/dashboard" replace />
        } 
      />

      {/* Protected routes */}
      <Route 
        path="/" 
        element={
          user ? <Layout user={user} setUser={setUser} /> : <Navigate to="/login" replace />
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard user={user} />} />
        <Route path="boards" element={<BoardsPage user={user} />} />
        <Route path="boards/:boardId" element={<BoardDetailPage user={user} />} />
        <Route path="whiteboard/:boardId" element={<WhiteboardPage user={user} />} />
        <Route path="miro/:boardId" element={<MiroWhiteboardPage user={user} />} />
        <Route path="content" element={<ContentPage user={user} />} />
        <Route path="ai-generator" element={<AIGeneratorPage user={user} />} />
        <Route path="analytics" element={<AnalyticsPage user={user} />} />
      </Route>

      {/* Catch all route */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App; 